export type ThemeVarKey =
  | '--bg' | '--surface' | '--surface2' | '--border'
  | '--text' | '--text2' | '--text3'
  | '--orange' | '--orange-light' | '--orange-dark' | '--og'
  | '--green' | '--green-light'
  | '--red' | '--red-light'
  | '--blue' | '--blue-light'
  | '--purple' | '--purple-light'
  | '--sh' | '--sh-lg'
  | '--r' | '--r-sm' | '--r-xs';

export type ThemeVars = Record<ThemeVarKey, string>;

export interface ThemeData extends ThemeVars {
  name: string;
}

export interface ThemeRecord {
  id: string;
  data: ThemeData;
  actual: boolean;
  isCurrent: boolean;
  created: string;
  updated: string;
}

export const THEME_VAR_KEYS: ThemeVarKey[] = [
  '--bg', '--surface', '--surface2', '--border',
  '--text', '--text2', '--text3',
  '--orange', '--orange-light', '--orange-dark', '--og',
  '--green', '--green-light',
  '--red', '--red-light',
  '--blue', '--blue-light',
  '--purple', '--purple-light',
  '--sh', '--sh-lg',
  '--r', '--r-sm', '--r-xs',
];

export const COLOR_VAR_KEYS = new Set<ThemeVarKey>([
  '--bg', '--surface', '--surface2', '--border',
  '--text', '--text2', '--text3',
  '--orange', '--orange-light', '--orange-dark',
  '--green', '--green-light',
  '--red', '--red-light',
  '--blue', '--blue-light',
  '--purple', '--purple-light',
]);

export const DEFAULT_THEME: ThemeData = {
  name: 'По умолчанию',
  '--bg': '#F2F2F7',
  '--surface': '#ffffff',
  '--surface2': '#F8F8FA',
  '--border': '#E8E8EE',
  '--text': '#1A1A2E',
  '--text2': '#6B6B80',
  '--text3': '#9B9BAA',
  '--orange': '#F5A623',
  '--orange-light': '#FFF3DC',
  '--orange-dark': '#E8920A',
  '--og': 'linear-gradient(135deg,#F5A623 0%,#FF7A00 100%)',
  '--green': '#4CAF50',
  '--green-light': '#E8F5E9',
  '--red': '#F44336',
  '--red-light': '#FFEBEE',
  '--blue': '#2196F3',
  '--blue-light': '#E3F2FD',
  '--purple': '#9C27B0',
  '--purple-light': '#F3E5F5',
  '--sh': '0 2px 12px rgba(0,0,0,.08)',
  '--sh-lg': '0 8px 32px rgba(0,0,0,.12)',
  '--r': '16px',
  '--r-sm': '10px',
  '--r-xs': '6px',
};
